// React Query hooks over the Firestore read layer. QueryClientProvider is
// already mounted in src/index.js (staleTime 60s), so these cache automatically.
import { useQuery } from "@tanstack/react-query";
import {
  fetchProducts,
  fetchProductBySlug,
  fetchProductsByCategory,
  fetchCategories,
  fetchCategoryBySlug,
  fetchSettings,
  fetchPageSeo,
  fetchPromoCodes,
} from "../lib/firestore";

export const useProducts = () =>
  useQuery({ queryKey: ["products"], queryFn: fetchProducts });

export const useProduct = (slug) =>
  useQuery({ queryKey: ["product", slug], queryFn: () => fetchProductBySlug(slug), enabled: !!slug });

export const useProductsByCategory = (slug) =>
  useQuery({ queryKey: ["products", "category", slug], queryFn: () => fetchProductsByCategory(slug), enabled: !!slug });

export const useCategories = () =>
  useQuery({ queryKey: ["categories"], queryFn: fetchCategories });

export const useCategory = (slug) =>
  useQuery({ queryKey: ["category", slug], queryFn: () => fetchCategoryBySlug(slug), enabled: !!slug });

export const useSettings = () =>
  useQuery({ queryKey: ["settings"], queryFn: fetchSettings });

// Page SEO overrides — cached longer since they change rarely.
export const usePageSeo = () =>
  useQuery({ queryKey: ["pageSeo"], queryFn: fetchPageSeo, staleTime: 5 * 60 * 1000 });

export const usePromoCodes = () =>
  useQuery({ queryKey: ["promoCodes"], queryFn: fetchPromoCodes });
